import { useState, type FC } from 'react';
import type { InputProps } from './types';
import { Input as ChakraUiInput } from '@chakra-ui/react';
import { BODY_CONFIG } from '@/components/Typography';

export const Input: FC<InputProps> = ({ onBlur, onFocus, isInvalid, ...props }) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [isFilled, setIsFilled] = useState<boolean>(false);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    setIsFilled(event.target.value !== "");

    if (onBlur) {
      onBlur(event);
    }
  };

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);

    if (onFocus) {
      onFocus(event);
    }
  };
  return (
    <ChakraUiInput
      placeholder=" "
      variant="unstyled"
      onFocus={handleFocus}
      onBlur={handleBlur}
      border="1px solid"
      borderColor={isInvalid ? 'red03' : 'transparent'}
      padding="16px"
      height="56px"
      color="shade02"
      backgroundColor="shade09"
      borderRadius="8px"
      sx={{
        ...BODY_CONFIG.Default16,
        '& ~ label': {
          top: isFocused || isFilled ? '12px' : '28px',
          color: isFocused || isFilled ? 'shade04' : 'shade05',
          ...(isFocused || isFilled
            ? (BODY_CONFIG.Default10)
            : (BODY_CONFIG.Default16)),
        },
      }}
      _autofill={{
        border: "1px solid transparent",
        boxShadow: "0 0 0px 1000px white inset",
        transition: "background-color 5000s ease-in-out 0s",
        WebkitTextSizeAdjust: '16px',
        ...BODY_CONFIG.Default16,
        '& ~ label': {
          top: '12px !important',
          color: 'shade04',
          ...BODY_CONFIG.Default10,
        }
      }}
      {...props}
    />
  )
}
